(function() {
    if (document.querySelector('.hero') && document.querySelector('.hero').getAttribute('data-count-slides') > 1) {
        const $classHero = 'hero';
        const swiperPaneCarousel1 = new Swiper(`.${$classHero}__carousel`, {
            wrapperClass: `${$classHero}__ribbon`,
            slideClass: `${$classHero}__slide`,
            direction: 'horizontal',
            loop: true,
            speed: 600,
            navigation: {
                prevEl: `.${$classHero}__controller--left`,
                nextEl: `.${$classHero}__controller--right`,
            },
            autoplay: {
                delay: 8000,
                disableOnInteraction: false, // Autoplay nie wyłącza się po ręcznej interakcji
            },
            effect: 'fade',
            fadeEffect: {
                crossFade: true
            },
            breakpoints: {
                0: {
                    allowTouchMove: true,
                },
                1280: {
                    allowTouchMove: false,
                },
            },
        });
    
        // ====
    
        const conindBlock1 = document.querySelector(`.${$classHero}__block`);
        const slideCount1 = swiperPaneCarousel1.slides.length;
        const blockWidthPercentage1 = 100 / slideCount1;
    
        // Set initial size and position
        conindBlock1.style.width = `${blockWidthPercentage1}%`;
        updateBlockPosition();
    
        // Update position on slide change
        swiperPaneCarousel1.on('slideChange', updateBlockPosition);
    
        function updateBlockPosition() {
            const activeIndex = swiperPaneCarousel1.realIndex;
            conindBlock1.style.left = `${blockWidthPercentage1 * activeIndex}%`;
        }

        // ====
        // Play/Pause button functionality
        const playPauseButton = document.querySelector('.hero__pause-or-play-icon');
        let isPlaying = true;

        playPauseButton.addEventListener('click', function() {
            if (isPlaying) {
                swiperPaneCarousel1.autoplay.stop(); // Zatrzymanie autoplay
                playPauseButton.classList.remove('hero__pause-or-play-icon--pause'); // Usuń klasę dla stanu pauzy
                playPauseButton.classList.add('hero__pause-or-play-icon--play'); // Dodaj klasę dla stanu odtwarzania
            } else {
                swiperPaneCarousel1.autoplay.start(); // Włączenie autoplay
                playPauseButton.classList.remove('hero__pause-or-play-icon--play'); // Usuń klasę dla stanu odtwarzania
                playPauseButton.classList.add('hero__pause-or-play-icon--pause'); // Dodaj klasę dla stanu pauzy
            }
            isPlaying = !isPlaying; // Zmiana stanu odtwarzania
        });

        // Inicjalna klasa przy starcie autoplay
        playPauseButton.classList.add('hero__pause-or-play-icon--pause');
    }
})();
